import {GetWalletResponse_Tab_Coins_CoinsHeader_StatusUpdate} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.types';
import {GenericIconName, StatusInfoBox} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {useMemo} from 'react';

export const StatusUpdate: React.FC<
  GetWalletResponse_Tab_Coins_CoinsHeader_StatusUpdate
> = ({type}) => {
  const StatusUpdateInfo = useMemo(() => {
    switch (type?.$case) {
      case 'expired':
        return (
          <StyledStatusInfoBox
            text={type.expired.text}
            icon={GenericIconName.Error}
            color="Coins.Red"
          />
        );
      case 'expiring':
        return (
          <StyledStatusInfoBox
            text={type.expiring.text}
            icon={GenericIconName.InfoFilledGray}
            iconSize="XSS"
            color="Coins.Orange"
          />
        );
      case 'confirmation':
        return (
          <StyledStatusInfoBox
            text={type.confirmation.text}
            icon={GenericIconName.AlertSuccessFill}
            color="Coins.Green"
          />
        );
      default:
        return null;
    }
  }, []);

  return <>{StatusUpdateInfo}</>;
};

const StyledStatusInfoBox = styled(StatusInfoBox)`
  height: 22px;
`;
